export enum TitleHomeV2Variant {
  H1 = "h1",
  H2 = "h2",
  H3 = "h3",
  H4 = "h4",
  BODY1 = "body1",
  BODY2 = "body2",
  BODY3 = "body3",
  BODY4 = "body4",
  SUBTITLE1 = "subtitle1",
  SUBTITLE2 = "subtitle2",
}
